









































































import Vue from 'vue';
import { Component, Mixins } from 'vue-property-decorator';
import LuxtagMixin from '@/assets/ts/mixins/LuxtagMixin';
import { EventBus } from '@/plugins/event-bus';

@Component
export default class Reporst extends Mixins(LuxtagMixin) {
    public productName: string = '';
    public productBrand: string = '';
    public storeName: string = '';
    public storeAddress: string = '';
    public dictionary = {
        attributes: {
        // email: 'E-mail Address',
        // password: 'Password',
        // custom attributess
        },
        custom: {
            productName: {
                required: () => 'Product name can not be empty',
                // custom messages
            },
            productBrand: {
                required: () => 'Product brand can not be empty',
                // custom messages
            },
            storeName: {
                required: 'Store name can not be empty',
            },
            storeAddress: {
                required: 'Store address can not be empty',
            },
        },
    };

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            // change navbar active style become non-active
            EventBus.$emit('change-hide-slider', true);
            EventBus.$emit('change-show-tab-active-color', false);
        });
    }

    public beforeRouteLeave(to: any, from: any, next: any) {
        // change back navbar active style become non-active
        EventBus.$emit('change-hide-slider', false);
        EventBus.$emit('change-show-tab-active-color', true);
        next();
    }

    public mounted() {
        this.$validator.localize('en', this.dictionary);
    }

    public submit() {
        // check if form is valid
        this.$validator.validateAll().then((valid) => {
        // for UI purpose everything is true now
        // TODO: change true to valid
        if (true) {
            // store auth
            // this.$store.commit('MUTATE_AUTH', {
            //   register: true,
            // });

            // // redirect to reported
            this.$router.push('/reported');
        }
        });
    }

    public clear() {
        this.productName = '';
        this.productBrand = '';
        this.storeName = '';
        this.storeAddress = '';
        this.$validator.reset();
    }
}
